import { MessagingClient } from "./messagingClient";
import { WidgetCommands, WidgetCommandTypes } from "./widgetCommands";

export const widgetClient = new MessagingClient<WidgetCommandTypes>(WidgetCommands);
